<template>
	<div class="login-wrapper">
		<img class="top-right" src="../../assets/login/img3.png" alt="" />
		<img class="bottom-left" src="../../assets/login/img2.png" alt="" />
		<div class="main-box dis-flex al-center">
			<img class="main" src="../../assets/login/main.png" alt="" />
			<div class="form-box">
				<div class="dis-flex jus-center" style="margin-bottom: 20px;"><img class="logo" src="../../assets/login/logo.png" /></div>
				<div class="">
					<el-form ref="form" :rules="rules" :model="form" label-width="80px">
						<el-form-item prop="name">
							<el-input prefix-icon="el-icon-user" class="el-input" placeholder="请输入账号" v-model="form.username"></el-input>
						</el-form-item>
						<el-form-item prop="pwd">
							<el-input @focus="focus" class="el-input" prefix-icon="el-icon-lock" show-password placeholder="请输入密码" v-model="form.password"></el-input>
						</el-form-item>
						<el-button :loading="loading" class="login-btn bgC txt-btn" @click="login('form')" type="primary">登录</el-button>
					</el-form>
					<div class="bottom-txt">️️️️️️️ ©2026心怡福技术支持</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			form: {
				username: '',
				password: ''
			},
			rules: {
				username: [{ required: true, message: '请输入账号', trigger: ['blur', 'change'] }],
				password: [{ required: true, message: '请输入密码', trigger: ['blur', 'change'] }]
			}
		};
	},
	created() {},
	methods: {
		focus(){
			document.addEventListener('keyup', (e)=>{
				if(e.key == 'Enter'){
					return this.login('form')
				}
			});
		},
		login(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.loading = true;
					this.$loginapi.login(this.form).then(res => {
							this.loading = false;
							console.log(res);
							if (res.code == 1) {
								localStorage.setItem('userInfo', JSON.stringify(res.data));
								// localStorage.setItem('token', 'sdfkjskfj21dsfgdf5g4d5fg54g');
								localStorage.setItem('isLogin', true);
								// this.$router.replace('/index');
								// this.$router.push({path:'/index'})
								// return
								location.href = '/';
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch(err => {
							this.loading = false;
						});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/css.css';
.login-wrapper {
	display: flex;
	justify-content: center;
	.top-right {
		z-index: -1;
		position: absolute;
		width: 34vw;
		height: 27vh;
		top: 0;
		right: 0;
	}
	.bottom-left {
		z-index: -1;
		position: absolute;
		height: 27.7vh;
		width: 9.3vw;
		bottom: 0;
		left: 0;
	}
	.main-box /deep/ {
		z-index: 10;
		height: 100vh;
		margin-top: -80px;
		.main {
			width: 500px;
			height: 500px;
		}
		.form-box {
			width: 300px;
			margin-top: 10px;
			padding: 20px 50px;
			.el-input {
				// margin: 5px 0;
			}
			margin-left: 20px;
			.logo {
				margin-bottom: 10px;
				width: 240px;
				// height: 70px;
			}
			.el-form-item__content {
				margin-left: 0 !important;
			}
		}
		.login-btn {
			width: 100%;
			margin-top: 5px;
			background-color: #004f9d;
			border: none !important;
		}
		.login-btn:active {
			background-color: #004f9d;
			opacity: 0.9;
		}
		.login-btn:hover {
			background-color: #004f9d;
			opacity: 0.8;
		}
		.bottom-txt {
			margin-top: 25px;
			color: gray;
			font-size: 12px;
			text-align: center;
		}
	}
}
</style>
